import React, { FormEvent, useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import { Alert, Button, IconButton, InputLabel, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

import { IBatchHistory, IBatch, IBatchHistoryAddRequest } from '../../types/shipment';

import { BatchService } from '../../services/batchService';

import Spinner from '../spinner';

import '../../styles/batchHistoryForm.scss';
import { UtilityService } from '../../services/utilityService';

export interface IBatchHistoryForm {
	id: string;
	status: string;
}

const BatchHistoryForm: React.FunctionComponent<IBatchHistoryForm> = ({ id, status }) => {
	const [batchHistory, setBatchHistory] = useState<IBatchHistory[]>([]);
	const [isLoadingHistory, setIsLoadingHistory] = useState(false);
	const [isAddingComment, setIsAddingComment] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [commentField, setCommentField] = useState<string>('');

	useEffect(() => {
		getBatchHistory();
	}, [id, status])

	const getBatchHistory = () => {
		setIsLoadingHistory(true);

		BatchService.getBatchHistory(id)
			.then((response) => {
				console.log('BatchService.getBatchHistory: SUCCESS', response);
				const comments = BatchService.mapBatchHistories(response.data); 
				setBatchHistory(comments.sort((a, b) => UtilityService.compareNumbers(b.date.getTime(), a.date.getTime())));
			})
			.catch((error) => {
				console.log('BatchService.getBatchHistory: ERROR', error);
				setErrorMessage("We encountered an error while loading batch history. Please try again.");
			})
			.finally(() => {				
				setIsLoadingHistory(false);
			});
	}

	const handleAdd = async (event: FormEvent<HTMLFormElement>) => {
		if (commentField.trim() === '') {
			return;
		}

		setIsAddingComment(true);

		const request: IBatchHistoryAddRequest = {
			description: commentField.trim()
		}
		BatchService.addHistoryComment(id, request)
			.then((response) => {
				console.log('BatchService.addHistoryComment: SUCCESS', response);
				var newComment = BatchService.mapBatchHistory(response.data);
				setBatchHistory([...batchHistory, newComment].sort((a: IBatchHistory, b: IBatchHistory) => UtilityService.compareNumbers(b.date.getTime(), a.date.getTime())));
				setCommentField('');
			})
			.catch((error) => {
				console.log('BatchService.addHistoryComment: ERROR', error);
				setErrorMessage("We encountered an error while posting the comment. Please try again.");
			})
			.finally(() => {
				setIsAddingComment(false);
			});
	}

	return (
		<section className="hwi-batch-history-form">
			<Spinner dependency={isLoadingHistory} text="Loading batch history...">
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					{errorMessage &&
						<Alert className="alert-error" severity="error" action={<IconButton onClick={() => { setErrorMessage(undefined); }} size='small'>X</IconButton>}>{errorMessage}</Alert>
					}
					<Form onSubmit={(event) => handleAdd(event)}>
						<div className="row">
							<div className="col-comment">
								<InputLabel>Add a Comment</InputLabel>
								<TextField className="comment-field"
									value={commentField}
									fullWidth
									onChange={(event) => { setCommentField(event.target.value) }}
								></TextField>
							</div>
							<div className="col-controls">
								<Button variant="contained" fullWidth type="submit" className="save-button" disabled={(isAddingComment) ? true : false} >{isAddingComment ? "Adding..." : "Add"}</Button>
							</div>
						</div>
					</Form>
					<div className="history-table">
						<div className="headers">
							<div className="col-date">Date</div>
							<div className="col-type">Type</div>
							<div className="col-username">User</div>
							<div className="col-description">Comment</div>
							{/* <div className="col-contorls"></div> */}
						</div>
						<div className="body">
							{batchHistory.length > 0 ? (
								<>
									{batchHistory.map((item, index) => (
										<div className="row" key={index}>
											<div className="col-date"><span>{dayjs(item.date).format('MM/DD/YYYY h:mm A')}</span></div>
											<div className="col-type">{item.type}</div>
											<div className="col-username">{item.username }</div>
											<div className="col-description">{item.description}</div>
											{/* <div className="col-controls">
												<Button onClick={() => handleRemove(item.id)} disabled={(isAdding || isRemovingId) ? true : false}>{isRemovingId == item.id ? "Removing..." : "Remove"}</Button>
											</div> */}
										</div>
									))}
								</>
							) : (
								<div className="no-results">This batch has no change history.</div>
							)}
						</div>
					</div>
					{/* <Json data={batchHistory}></Json> */}
				</LocalizationProvider>
			</Spinner>
		</section>
	)
}

export default BatchHistoryForm;